import { Button as ChakraButton, ButtonProps } from '@chakra-ui/button'
import { ChakraComponent, forwardRef } from '@chakra-ui/react'
import React from 'react'
import { Chevron, Direction } from '../../icons'

export interface IButtonProps extends ButtonProps {
  withLeftArrow?: boolean
  withRightArrow?: boolean
}

export const Button = forwardRef<IButtonProps, ChakraComponent<'button'>>(
  ({ children, withLeftArrow, withRightArrow, ...restProps }, ref) => (
    <ChakraButton
      leftIcon={withLeftArrow ? <Chevron /> : undefined}
      ref={ref}
      rightIcon={withRightArrow ? <Chevron direction={Direction.Right} /> : undefined}
      sx={{ _disabled: { cursor: 'default', opacity: 0.6, pointerEvents: 'none' } }}
      {...restProps}>
      {children}

    </ChakraButton>
  ),
)
